module.exports = __webpack_public_path__ + "static/support247-97d8141f9dd14341e755b85293e3c247.png";